import React, { useEffect, useState } from "react";

import { DSButton, DSModal, DSTextInput } from "./ds";
import { isValidEmail } from "../helpers/Utils";

/**
 * 리포트 수신 이메일 입력 모달 (기존 Elements.SendMailModal과 동일한 props 계약의 DS 버전).
 *
 * @param {boolean} open
 * @param {Function} onClose
 * @param {string} title - 모달 타이틀 (기본 "리포트 다운로드")
 * @param {string} reportName - 기본 안내 문구에 들어갈 리포트 이름
 * @param {React.ReactNode} description - 안내 문구 커스텀 (없으면 reportName 기반 기본 문구)
 * @param {Function} onSendEmail - (email) 보내기 확정
 */
const ReportMailModal = React.memo(
  ({ open, onClose, title, reportName, description, onSendEmail }) => {
    const [email, setEmail] = useState("");
    useEffect(() => {
      if (!open) {
        setEmail("");
      }
    }, [open]);
    return (
      <DSModal
        open={open}
        onClose={onClose}
        title={title || "리포트 다운로드"}
        width={480}
        height="auto"
      >
        <div
          style={{
            padding: 24,
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <div className="ds-t-body-s-sub">
            {description || (
              <>
                {`${reportName} 파일이 준비되면 메일로 보내드리겠습니다.`}
                <br />
                {"파일을 전송 받으실 메일 주소를 입력해 주세요."}
                <br />
                {"데이터의 양에 따라 발송시간이 다를 수 있습니다."}
              </>
            )}
          </div>
          <DSTextInput
            type="email"
            value={email}
            onChange={setEmail}
            placeholder="이메일을 입력해주세요."
          />
        </div>
        <div
          style={{
            padding: 16,
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            borderTop: "1px solid var(--ds-border-default)",
          }}
        >
          <DSButton variant="secondary" size="lg" onClick={onClose}>
            취소
          </DSButton>
          <DSButton
            variant="primary"
            size="lg"
            onClick={() => onSendEmail(email)}
            disabled={!isValidEmail(email)}
          >
            보내기
          </DSButton>
        </div>
      </DSModal>
    );
  },
);

export default ReportMailModal;
